import { useQuery } from '@tanstack/react-query';
import { fetchLiveClasses } from '../../queries/LiveClasses';

function useFetchLiveClasses(startDate: string, endDate: string, origin: 'aprova-live' | 'challenge') {
  const { data, isError, error, isSuccess, isPending, refetch } = useQuery({
    queryKey: ['fetch-live-classes', startDate, endDate, origin],
    queryFn: () => fetchLiveClasses(startDate, endDate, origin),
    retry: false,
    refetchOnWindowFocus: false
  });

  return {
    data,
    isError,
    isLoading: isPending,
    error,
    isSuccess,
    refetch,
  };
}

export { useFetchLiveClasses };
